import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const ActionForwardIcon = ({ color = 'white', ...props }: { color?: string } | any) => {
	return (
		<Icon
			width="auto"
			height="16px"
			viewBox="0 0 8.25 15"
		>
			<path
				d="M18.083,9.042,11.625,15.5l6.458,6.458"
				transform="translate(19.144 23.019) rotate(180)"
				fill="none"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.5"
			/>
		</Icon>
	);
};
